import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { inputTags, textInputTypes } from './enums';
import activeElement from './active_element'; // Indicates if the passed element is considered a text input.
//

var isTextInput = function isTextInput(element) {
  return inputTags[element.tagName] && textInputTypes[element.type];
}; // Assigns focus to the appropriate element... preferring the explicitly passed selector
//
// * selector - a CSS selector for the element that should have focus
//


var assignFocus = function assignFocus(selector) {
  var element = selector && selector.nodeType === Node.ELEMENT_NODE ? selector : document.querySelector(selector);
  var focusElement = element || activeElement.element;
  if (focusElement && focusElement.focus) focusElement.focus();
}; // Dispatches an event on the passed element
//
// * element - the element
// * name - the name of the event
// * detail - the event detail
//


var dispatch = function dispatch(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = {
    bubbles: true,
    cancelable: true,
    detail: detail
  };
  var evt = new CustomEvent(name, init);
  element.dispatchEvent(evt);
  if (window.jQuery) window.jQuery(element).trigger(name, detail);
}; // Accepts an xPath query and returns the element found at that position in the DOM
//


var xpathToElement = function xpathToElement(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}; // Return an array with the class names to be used
//
// * names - could be a string or an array of strings for multiple classes.
//


var getClassNames = function getClassNames(names) {
  return Array(names).flat();
}; // Perform operation for either the first or all of the elements returned by CSS selector
//
// * operation - the instruction payload from perform
// * callback - the operation function to run for each element
//


var processElements = function processElements(operation, callback) {
  Array.from(operation.selectAll ? operation.element : [operation.element]).forEach(callback);
}; // camelCase to kebab-case
//


var kebabize = function kebabize(str) {
  return str.split('').map(function (letter, idx) {
    return letter.toUpperCase() === letter ? "".concat(idx !== 0 ? '-' : '').concat(letter.toLowerCase()) : letter;
  }).join('');
}; // Provide a standardized pipeline of checks and modifications to all operations based on provided options
// Currently skips execution if cancelled and implements an optional delay
//


var operate = function operate(operation, callback) {
  if (!operation.cancel) {
    operation.delay ? setTimeout(callback, operation.delay) : callback();
    return true;
  }

  return false;
}; // Dispatch life-cycle events with standardized naming


var before = function before(target, operation) {
  return dispatch(target, "cable-ready:before-".concat(kebabize(operation.operation)), operation);
};

var after = function after(target, operation) {
  return dispatch(target, "cable-ready:after-".concat(kebabize(operation.operation)), operation);
};

function debounce(func, timeout) {
  var _this = this;

  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      return func.apply(_this, args);
    }, timeout);
  };
}

function handleErrors(response) {
  if (!response.ok) throw Error(response.statusText);
  return response;
} // A proxy method to wrap a fetch call in error handling
//
// * url - the URL to fetch
// * additionalHeaders - an object of additional headers passed to fetch
//


function graciouslyFetch(_x, _x2) {
  return _graciouslyFetch.apply(this, arguments);
}

function _graciouslyFetch() {
  _graciouslyFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, additionalHeaders) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              headers: _objectSpread({
                'X-REQUESTED-WITH': 'XmlHttpRequest'
              }, additionalHeaders)
            });

          case 3:
            response = _context.sent;

            if (!(response == undefined)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            handleErrors(response);
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.error("Could not fetch ".concat(url));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _graciouslyFetch.apply(this, arguments);
}

export { isTextInput, assignFocus, dispatch, xpathToElement, getClassNames, processElements, operate, before, after, debounce, handleErrors, graciouslyFetch };